let mainPath = "/RFID";
let viewFolder = "RFID";

module.exports = [
    {
        path: mainPath,
        name: 'RFID',
        component: () => import('../views/'+viewFolder+'/Index.vue'),
    },
    {
        path: mainPath+'/register',
        name: 'Register Items',
        component: () => import('../views/'+viewFolder+'/Register.vue'),
    },
    {
        path: mainPath+'/track',
        name: 'Track Items',
        component: () => import('../views/'+viewFolder+'/Track.vue'),
    },
    {
        path: mainPath+'/deregister',
        name: 'Deregister Items',
        component: () => import('../views/'+viewFolder+'/Deregister.vue'),
    },
]